import { Component, input, inject } from '@angular/core';
import { Order } from '../../../shared/classes/order';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { Document } from '../../../shared/classes/document';
import { DocumentType } from '../../../shared/classes/document-type.enum';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LoadingPopupComponent } from '../../../popups/loading-popup/loading-popup.component';
import { SupplierApiService } from '../../../shared/services/supplier-api.service';

@Component({
    selector: 'app-document-uploader',
    templateUrl: './document-uploader.component.html',
    styleUrls: ['./document-uploader.component.css'],
    imports: [FileUploadModule]
})
/**
 * The box that allows a user to select the documents that they want
 * to upload of a certain document type.
 */
export class DocumentUploaderComponent {
    private dialog = inject(MatDialog);
    private supplierApiService = inject(SupplierApiService);

    public readonly order = input.required<Order>();
    public readonly documentType = input.required<string>();
    // The component handles the actual upload through the supplier API service; ng2-file-upload
    // is only used for file selection and queue events.
    public uploader: FileUploader = new FileUploader({ url: '' });

    /**
     * Whether or not a document should have a red star next to its name.
     *
     * @return whether the document is required.
     */
    isRequired(): boolean {
        const documentType = this.documentType();
        return (
            documentType === DocumentType.FAIR || documentType === DocumentType.COC || documentType === DocumentType.RFQ
        );
    }

    /**
     * Removes the document at the given index from the order's document map.
     *
     * @param index, the index of the document to be removed
     */
    documentRemove(index: number): void {
        this.order().documents.get(this.documentType()).splice(index, 1);
        this.order().unsaved = true;
    }

    /**
     * Uses AWS Service to upload a new set of documents and opens a popup while
     * waiting. Assigns the unique index returned by the lamdba to the document.
     *
     * @param files The files to be uploaded
     */
    uploadFiles(files: File[]): void {
        Array.from(files).forEach((file) => {
            const promise = this.supplierApiService.uploadNewFile(file).then((id) => {
                const newDocument = new Document(file.name, id, new Date());
                const documentType = this.documentType();
                const order = this.order();
                if (order.documents.get(documentType)) {
                    order.documents.get(documentType).push(newDocument);
                } else {
                    order.documents.set(documentType, [newDocument]);
                }
                order.unsaved = true;
            });
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                promise
            };
            this.dialog.open(LoadingPopupComponent, dialogConfig);
        });
    }
}
